import { b } from './chunk-IMSWER4T.js';

var o=class extends b{URL="organisation";async getOrganisationUsers(r){return (await this._client.get(`/organisation/${r}/users`)).data}async updateBillingUsers(r,e){return await(await this._client.put(`/organisation/${r}/billing-users`,{user_ids:e.user_ids})).data}async restoreOrganisation(r){await this._client.post(`/organisation/${r}/restore`);}};

export { o as a };
//# sourceMappingURL=chunk-AJ26P6ZX.js.map
//# sourceMappingURL=chunk-AJ26P6ZX.js.map